import { render, staticRenderFns } from "./ServicesReservationTreatmentPlans.vue?vue&type=template&id=17630479&"
import script from "./ServicesReservationTreatmentPlans.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationTreatmentPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports